import React, { Fragment } from 'react';
const Decorator = {
   /**
   * @param {String} str Noun or sentence to capitalize
   */
    capitalizeFirst: function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
    },
    formatCurrency(currencyAmount) {
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2
          });
        let formatted = formatter.format(currencyAmount);
        return isNaN(currencyAmount) ? 'Invalid Selection' : formatted;
    },
    displayIconForPortionAndSize(portion, size) {
        if(size === 'light') {
            return <span className="mif-minus store-fg-accent" ></span>;
        }
        if(portion === 'whole') {
            return <span className="icon-full-circle store-fg-accent" ></span>;
        }
        if(portion === 'first-half') {
            return <span className="icon-left-circle store-fg-accent" ></span>;
        }
        if(portion === 'second-half') {
            return <span className="icon-right-circle store-fg-accent" ></span>;
        }
        return <span className="icon-empty-circle store-fg-accent" ></span>;
    },
    containsSpecialCharacter(text) {
        if(text.includes('~')) return true;
        if(text.includes('!')) return true;
        if(text.includes('@')) return true;
        if(text.includes('#')) return true;
        if(text.includes('$')) return true;
        if(text.includes('%')) return true;
        if(text.includes('^')) return true;
        if(text.includes('&')) return true;
        if(text.includes('*')) return true;
        if(text.includes('(')) return true;
        if(text.includes(')')) return true;
        if(text.includes('-')) return true;
        if(text.includes('`')) return true;
        if(text.includes('_')) return true;
        if(text.includes('=')) return true;
        if(text.includes('+')) return true;
        if(text.includes('{')) return true;
        if(text.includes('[')) return true;
        if(text.includes('}')) return true;
        if(text.includes(']')) return true;
        if(text.includes('|')) return true;
        if(text.includes(';')) return true;
        if(text.includes(':')) return true;
        if(text.includes("'")) return true;
        if(text.includes('"')) return true;
        if(text.includes(',')) return true;
        if(text.includes('<')) return true;
        if(text.includes('.')) return true;
        if(text.includes('>')) return true;
        if(text.includes('?')) return true;
        if(text.includes('/')) return true;
        return false;
    },
    containsCapitalLetter(text) {
        if(text.includes('A')) return true;
        if(text.includes('B')) return true;
        if(text.includes('C')) return true;
        if(text.includes('D')) return true;
        if(text.includes('E')) return true;
        if(text.includes('F')) return true;
        if(text.includes('G')) return true;
        if(text.includes('H')) return true;
        if(text.includes('I')) return true;
        if(text.includes('J')) return true;
        if(text.includes('K')) return true;
        if(text.includes('L')) return true;
        if(text.includes('M')) return true;
        if(text.includes('N')) return true;
        if(text.includes('O')) return true;
        if(text.includes('P')) return true;
        if(text.includes('Q')) return true;
        if(text.includes('R')) return true;
        if(text.includes('S')) return true;
        if(text.includes('T')) return true;
        if(text.includes('U')) return true;
        if(text.includes('V')) return true;
        if(text.includes('W')) return true;
        if(text.includes("X")) return true;
        if(text.includes('Y')) return true;
        if(text.includes('Z')) return true;
        return false;
    },
    containsNumber(text) {
        if(text.includes('1')) return true;
        if(text.includes('2')) return true;
        if(text.includes('3')) return true;
        if(text.includes('4')) return true;
        if(text.includes('5')) return true;
        if(text.includes('6')) return true;
        if(text.includes('7')) return true;
        if(text.includes('8')) return true;
        if(text.includes('9')) return true;
        if(text.includes('0')) return true;
        return false;
    },
    /**
     *
     * @param {String} title Title of notification
     * @param {String} msg Message contetn
     * @param {String} cssClass Custom string of CSS classes
     * @param {Function} [callback] Callback to be executed (optional)
     */
    notify(title, msg, cssClass, callback) {

    },
    clearNotifications() {

    },
    scrollTop() {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    /**
     *
     * @param {String} inputString String to be broken into multiple paragraphs
     */
    multiLineParagraph(inputString, clsName) {
        let inputArr = inputString.split('<br />');
        let paragraphs = inputArr.map( (val, ind, arr) => {
            return <p key={ind} className={clsName}>{val}</p>;
        });
        return (
            <Fragment>
                {paragraphs}
            </Fragment>
        )
    },
    toProper(str) {
    return str.replace(
        /\w\S*/g,
        function(txt) {
            return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
        }
    );
},
    addFloatsAndFormatCurrency(floatArray) {
    // Convert each item in the array to a float using parseFloat()
    const parsedFloatArray = floatArray.map(item => parseFloat(item));

    // Calculate the total sum of the array elements
    const totalSum = parsedFloatArray.reduce((acc, curr) => acc + curr, 0);

    // Format the sum as a currency string
    const currencyFormattedSum = totalSum.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD', // Change this to the appropriate currency code if needed
        minimumFractionDigits: 2,
    });

    return currencyFormattedSum;
},
    subtractDecimals(num1, num2) {
        const decimalNum1 = Number(num1);
        const decimalNum2 = Number(num2);

        if (isNaN(decimalNum1) || isNaN(decimalNum2)) {
            return "Invalid input. Please provide valid decimal numbers.";
        }

        const result = decimalNum1 - decimalNum2;
        return result;
    }

};

export default Decorator;
